// src/services/account.js
import api from './axios';

export async function changePassword({ currentPassword, newPassword, logoutOthers = true }) {
  const { data } = await api.post('/auth/change-password', { currentPassword, newPassword, logoutOthers });
  return data;
}
